import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const BeneficiaryMultiApprovalDeclined = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigationType = location.state?.type;
  const [declinedPageData, setDeclinedPageData] = useState([]);

  const buttonRows = [
    [
      ...(navigationType !== "recreate_Multi"
        ? [
            {
              btnText: "Reject more transaction",
              enabledBgColor: "var(--text-primary)",
              enabledTextColor: "var(--positive-bg)",
              icon: ICONS?.APPROVE_MORE_TXN,
              imgColor: "var(--positive-bg)",
              handleFunction: () =>
                navigate(
                  "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval",
                  { replace: true },
                ),
              iconToBeAlign: "left",
              fullWidthRequired: true,
              hoverOption: "dark",
            },
          ]
        : []),
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () =>
          navigate("/beneficiary_transaction_dashboard", { replace: true }),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: txn?.beneficiary_account_name,
              leftSubTitle: "Beneficiary name",
              rightText: true,
              rightIcon: true,
              rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
            },
          ]}
        />
      ))}
    </>
  );

  const totalTransactions = declinedPageData?.length || 0;

  const titleText =
    totalTransactions === 1
      ? "Transaction has been rejected."
      : "Transaction have been rejected.";

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setDeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setDeclinedPageData([]);
    }
  }, []);

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={
        navigationType === "recreate_Multi"
          ? "Transactions rejected and sent for recreation"
          : titleText
      }
    >
      <TabsWeapperSection
        title={`Rejected transactions - ${declinedPageData?.length}`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default BeneficiaryMultiApprovalDeclined;
